/* ============
 * Global event bus
 * ============
 *
 * A Vue instance used to be the bus (`new Vue()` + `$on`/`$emit`), a pattern
 * removed in Vue 3. It is now backed by `mitt`, which exposes the same
 * publish/subscribe surface (`on` / `off` / `emit`).
 */
import mitt from 'mitt';

const emitter = mitt();

export default {
  on: emitter.on,
  off: emitter.off,
  emit: emitter.emit,
  editJob(data) {
    emitter.emit('editJob', data);
  },
  cancelJob(data) {
    emitter.emit('cancelJob', data);
  },
};
